<div class="dialog-content">
  <form class="k-form" [formGroup]="absenceTypeForm()">
    <kendo-formfield orientation="horizontal">
      <kendo-label class="!k-align-items-start" [for]="reason" text="Grund"></kendo-label>
      <div class="k-d-flex">
        <kendo-dropdownlist
          [data]="absenceReasonOptions"
          textField="text"
          valueField="value"
          formControlName="reason"
          (selectionChange)="absenceReasonChanged($event)"
          #reason
        >
        </kendo-dropdownlist>
        <span #popupAnchor class="k-align-self-center">
          <a shivePopup [popupAnchor]="popupAnchor" [content]="popupContent">
            <fa-icon class="k-ml-2.5 turquoise" [icon]="faCircleInfo" size="lg"></fa-icon>
          </a>
        </span>
      </div>
      <kendo-formerror>Error: Full Name is required</kendo-formerror>
    </kendo-formfield>

    <kendo-formfield orientation="horizontal">
      <kendo-label
        class="!k-align-items-start !k-justify-content-flex-start k-mt-2"
        [for]="description"
        text="Beschreibung"
      ></kendo-label>
      <kendo-textarea
        formControlName="description"
        style="height: calc(1.5em * 3)"
        resizable="auto"
        #description
      >
      </kendo-textarea>
    </kendo-formfield>

    <app-date-and-time-input-dialog
      [workTimeStart]="workTimeStart()"
      [workTimeEnd]="workTimeEnd()"
      [timeBlock]="selectedTimeBlock()"
      [form]="absenceTypeForm()"
      [(fixIntervalDropdownVisible)]="fixIntervalDropdownVisible"
    ></app-date-and-time-input-dialog>
  </form>
</div>

<ng-container [ngTemplateOutlet]="footer()"></ng-container>
